<template>
  <a-row type="flex">
    <a-col :span="10" class="enterprise_page_title">Portfolio</a-col>
  </a-row>
  <a-row type="flex" justify="center">
    <a-col v-for="(item, index) in enterprise.items" :key="index" class="enterprise_item" @click="showmodal(index)">
      <img :src="item.trademark">
      <p style="color: grey; margin-top: 3vh; font-size: 16px">{{ item.name_en }}</p>
    </a-col>
    <a-col v-for="(item, index) in enterprise.perished" :key="index" class="enterprise_item">
      <img :src="item.trademark">
      <p style="color: grey; margin-top: 3vh; font-size: 16px">{{ item.name_en }}</p>
    </a-col>
  </a-row>
  <a-modal v-model:visible="modal.visible" @click="close"
           :centered="true" :footer="null" :width="'40vh'"
           :bodyStyle="{padding: 0,}" :destroyOnClose="true">
    <div v-if="modal.picture_owner" class="enterprise_item_detail">
      <img :src="modal.picture_owner">
      <div style="z-index: 2;position: absolute; top:26vw; left: 6vw">
        <p style="margin: 0; font-size: 18px">{{ modal.name }}</p>
        <p>——</p>
        <p style="font-size: 18px">{{ modal.owner }}</p>
      </div>
      <a-row style="display: flex; align-items: center" class="text_field">
        <div style="text-align: center; width: 40vh">
          <a-row style="padding-top: 1vh">
            <p style="font-size: 3vh;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
              {{ modal.name }}</p>
            <LinkOutlined v-if="(modal.site)" @click="tosite(modal.site)"
                          style="font-size: 3vh;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
          </a-row>
          <ul style="text-align: center; width: 35vh; margin-bottom: 1vh;max-height: 60vw;overflow-y: scroll">
            <li v-for="(item, index) in modal.introduction" :key="index"
                style="text-align: left;font-size: 2vh; margin-bottom: 1em">
              {{ item }}
            </li>
          </ul>
          <a-row style="text-align: center">
            <img :src="modal.trademark"
                 style="height: 8vh; width: auto;filter: brightness(100%);">
          </a-row>
        </div>
      </a-row>

    </div>
    <div v-else>
      <div style="width: 40vh; text-align: center;height: 80vh; margin: 0">
        <a-row style="padding-top: 2vw;">
          <p style="font-size: 32px;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
            {{ modal.name }}</p>
          <LinkOutlined v-if="(modal.site)" @click="tosite(modal.site)"
                        style="font-size: 26px;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
        </a-row>
        <p style="color: dimgrey">—————</p>
        <ul style="text-align: center; width: 35vh; margin: 0 1vh;overflow-x: hidden;height: 50vh;max-height: 50vh;font-size: 16px;overflow-y: scroll">
          <li v-for="(item, index) in modal.introduction" :key="index"
              style="text-align: left; margin-bottom: 1em;font-size: 16px;">
            {{ item }}
          </li>
        </ul>
        <a-row style="height: 6vw;text-align: center">
            <img :src="modal.trademark"
                 style="width:250px; max-height: 10vh; filter: brightness(100%);">
          </a-row>
      </div>
    </div>
  </a-modal>
</template>

<script>
import axios from 'axios'
import {reactive, onMounted} from 'vue'
import {LinkOutlined} from "@ant-design/icons-vue/"

export default {
  name: 'Enterprise_page_en_m',
  components: {LinkOutlined},
  setup() {
    const enterprise = reactive({
      items: [],
      perished: [],
    })
    let modal = reactive({
      name: '',
      site: '',
      owner: '',
      introduction: '',
      picture_owner: '',
      trademark: '',
      visible: false,
    })
    const tosite = (site) => {
      window.open(site)
    }
    const showmodal = (index) => {
      modal.name = enterprise.items[index]['name_en']
      modal.site = enterprise.items[index]['site']
      modal.owner = enterprise.items[index]['owner_en']
      modal.introduction = enterprise.items[index]['introduction_en']
      modal.picture_owner = enterprise.items[index]['picture_owner']
      modal.trademark = enterprise.items[index]['trademark']
      modal.visible = true
    }
    const close = () => {
      modal.visible = false
    }
    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/enterprise')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i]["status"] === 'perished') {
                enterprise.perished.push(res.data[i])
              } else {
                enterprise.items.push(res.data[i])
              }
            }
            enterprise.items.sort(function (a, b) {
              return a.name_en.localeCompare(b.name_en)
            })
            enterprise.perished.sort(function (a, b) {
              return a.name_en.localeCompare(b.name_en)
            })
             for (let i = 0; i < enterprise.items.length; i++) {
              enterprise.items[i]["trademark"] = 'https://sig-china.com' + enterprise.items[i]["trademark"]
              if (enterprise.items[i]["picture_owner"]) {
                enterprise.items[i]["picture_owner"] = 'https://sig-china.com' + enterprise.items[i]["picture_owner"]
              }
              if (enterprise.items[i]["introduction_en"].indexOf('\r\n') !== -1) {
                let temp = enterprise.items[i]["introduction_en"]
                enterprise.items[i]["introduction_en"] = []
                while (temp.indexOf('\r\n') !== -1) {
                  let pointer = temp.indexOf('\r\n')
                  enterprise.items[i]["introduction_en"].push(temp.slice(0, pointer))
                  temp = temp.slice(pointer + 2,)
                }
                enterprise.items[i]["introduction_en"].push(temp)
              } else {
                enterprise.items[i]["introduction_en"] = [enterprise.items[i]["introduction_en"]]
              }
            }
            for (let i = 0; i < enterprise.perished.length; i++) {
              enterprise.perished[i]["trademark"] = 'https://sig-china.com' + enterprise.perished[i]["trademark"]
            }
          })
    })
    return {enterprise, modal, showmodal, close, tosite}
  },
}
</script>

<style scoped>
.enterprise_item {
  border-style: solid;
  border-width: 1px;
  border-color: #f8f8f8;
  width: 50vw;
  height: auto;
}

.enterprise_item img {
  padding-top: 4vh;
  width: auto;
  height: 90px;
  max-width: 44vw;
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}

.enterprise_item img:hover {
  -webkit-filter: inherit;
  -moz-filter: inherit;
  -ms-filter: inherit;
  -o-filter: inherit;
  filter: inherit;
  filter: inherit;
}

.enterprise_page_title {
  background: #2f54eb;
  color: white;
  font-size: 14px;
  text-align: left;
  line-height: 40px;
  padding-left: 2vh;
  text-indent: 2em;
}


.enterprise_item_detail img {
  width: 100%;
  height: 100%;
  max-width: 40vh;
  filter: brightness(80%)
}

.text_field{
  height: calc(94vh - 40vh);
}
</style>
